<template>
  <div class="job-item-container" :class="!jobObj.allow_fetch_application && 'not-allow-application'">
    <span v-auto-tooltip.always="$t(`${i18nPrefix}.tips.hotJob`)" class="hot-icon iconfont iconFire" :class="jobObj.is_hot && 'is-hot'" @click="handelHotIconClick"></span>
    <div class="checkbox-container">
      <el-checkbox size="large" v-model="jobObj.checked"/>
      <div class="mask" @click="handelCheckedJob"></div>
    </div>
    <div class="job-basic-info">
      <span v-if="jobObj.allow_fetch_application" v-auto-tooltip class="job-title" @click="handelToApplication">
        {{ jobTitle }}
      </span>
      <span v-else class="job-title not-allow-application">
        <span v-auto-tooltip class="job-title-inner">{{ jobTitle }}</span>
        <span v-auto-tooltip.always="$t(`${i18nPrefix}.message.notAllowApplication`)" class="not-allow-tip">
          <i class="el-icon-question"></i>
        </span>
      </span>
      <div class="basic-info">
        <span class="id">ID{{ jobObj.id }}</span>
        <span v-auto-tooltip class="creator">{{ jobObj.creator.name }}</span>
        <span class="open-date">{{ openDate }}</span>
      </div>
      <span v-auto-tooltip class="job-location">{{ jobLocation }}</span>
      <div class="channel-container">
        <span v-if="defaultChannel" v-auto-tooltip.always="generateChannelTips(defaultChannel)" class="channel-icon iconfont" :class="[CHANNEL_ICON_MAPPING[`channel_${defaultChannel.key}`], defaultChannel.actionClass]"></span>
        <span v-auto-tooltip.always="$t(`${i18nPrefix}.tips.${referralStatusIconMapping[jobObj.referral_status] || 'draft'}`)" v-show="hasReferralPermission && jobObj.referral_status && jobObj.has_referral_premium" :class="['channel-icon',  'iconfont',  'iconReferral1', referralStatusIconMapping[jobObj.referral_status]]"/>
        <div class="icon-container">
          <div ref="channelIcon" class="channel-icon-container">
            <span
              v-for="(item, index) in displayChannelList"
              :key="index"
              v-auto-tooltip.always="generateChannelTips(item)"
              class="channel-icon iconfont"
              :class="[CHANNEL_ICON_MAPPING[`channel_${item.key}`], item.actionClass]"
            >
            </span>
          </div>
        </div>
        <div class="pv-share-container">
          <el-tooltip
            effect="light"
            popper-class="light-tooltip-popper"
          >
            <span class="pv-uv-icon iconfont iconView"></span>
            <template #content>
              <div class="pv-share-tooltip-container">
                <span class="title">{{ $t(`${i18nPrefix}.tips.pageViews`) }}</span>
                <div class="channel-statistic-list">
                  <div class="channel-statistic pv-uv-container">
                    <span class="channel-icon iconfont" :class="CHANNEL_ICON_MAPPING.channel_ajinga"></span>
                    <span class="channel-count">{{ jobObj.pv | formatBigNumber }}</span>
                  </div>
                  <template v-if="statisticChannelInfo && channelStatistic">
                    <div v-for="(channel, index) in statisticChannelList" class="channel-statistic" :key="index">
                      <span class="channel-icon iconfont" :class="CHANNEL_ICON_MAPPING[`channel_${channel.key}`]"></span>
                      <span class="channel-count">{{ getChannelStatistic(channel) | formatBigNumber }}</span>
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </el-tooltip>
          <span class="number pv-uv">{{ totalPv | formatBigNumber }}</span>
          <span v-auto-tooltip.always="$t(`${i18nPrefix}.tips.share`)" class="iconfont iconShare"></span>
          <span class="number share">{{ (jobObj.share || 0) | formatBigNumber }}</span>
        </div>
      </div>
      <div class="operate-container">
        <template v-if="isJobClosed">
          <el-button v-auto-tooltip.always="$t(`${i18nPrefix}.tips.jobClosed`)" type="primary" class="publish-button disabled" plain>{{ $t(`${i18nPrefix}.btn.publish`) }}</el-button>
        </template>
        <template v-else>
          <el-button type="primary" class="publish-button" @click="handelPublish" plain>{{ $t(`${i18nPrefix}.btn.publish`) }}</el-button>
        </template>
        <span v-auto-tooltip.always="$t(`${i18nPrefix}.tips.editJob`)" class="edit-icon iconfont iconEditor" @click="handelToEditJob"></span>
        <el-dropdown trigger="click" placement="bottom-start" @command="handelActionClick">
          <span v-auto-tooltip.always="$t(`${i18nPrefix}.tips.more`)" class="iconfont icona-xingzhuangbeifen8"></span>
          <el-dropdown-menu class="job-list-item-dropdown-container" slot="dropdown">
            <el-dropdown-item v-if="!isJobClosed && hasJobEditPermission" command="refresh">{{ $t(`${i18nPrefix}.label.refresh`) }}</el-dropdown-item>
            <el-dropdown-item v-if="!isJobClosed && hasAgencyManagementPermission" command="postToAgency">{{ $t(`${i18nPrefix}.label.postToAgency`) }}</el-dropdown-item>
            <el-dropdown-item command="share">{{ $t(`${i18nPrefix}.label.generateJobShare`) }}</el-dropdown-item>
            <template v-if="!isJobClosed && hasUploadCandidatePermission && jobObj.allow_fetch_application">
              <div v-if="disabledAddCandidate" v-auto-tooltip.always="disabledAddCandidateTip" class="dropdown-item is-disabled">
                {{ $t(`${i18nPrefix}.label.addCandidate`) }}
              </div>
              <el-dropdown-item v-else>
                <el-popover
                  placement="right"
                  trigger="hover"
                  popper-class="add-candidate-action-container"
                >
                  <div class="popover-item" @click="addCandidate">{{ $t('admin.application.candidate.label.switchFullResume') }}</div>
                  <div class="popover-item" @click="addCandidateBasicInfo">{{ $t('admin.application.candidate.label.switchMiniResume') }}</div>
                  <template #reference>
                    <div>{{ $t(`${i18nPrefix}.label.addCandidate`) }}</div>
                  </template>
                </el-popover>
              </el-dropdown-item>
              <div v-if="jobObj.allow_fetch_application && disabledAddCandidate" v-auto-tooltip.always="disabledAddCandidateTip" class="dropdown-item is-disabled">
                  {{ $t(`${i18nPrefix}.label.batchAddCandidate`) }}
              </div>
              <el-dropdown-item v-else-if="jobObj.allow_fetch_application" command="batchAddCandidate">{{ $t(`${i18nPrefix}.label.batchAddCandidate`) }}</el-dropdown-item>
            </template>
            <el-dropdown-item v-if="!isJobClosed && hasReferralPermission && jobObj.has_referral_premium" command="setReferral">{{ $t(`${i18nPrefix}.label.setReferral`) }}</el-dropdown-item>
            <el-dropdown-item v-if="!isJobClosed && hasJobClosePermission" command="close">{{ $t(`${i18nPrefix}.label.closeJob`) }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div v-if="jobFilterBindingList" class="custom-field-option">
      <Dropdown
        v-model="jobObj.job_filter_binding"
        class="custom-field-dropdown"
        :data="jobFilterBindingList"
        :empty="'-'"
        :isShowColorChange="true"
        @change="handleFilterBinding"
      />
    </div>
    <el-popconfirm
      v-if="showJobStatusSwitch"
      :title="$t(`${i18nPrefix}.message.confirmAction`)"
      @confirm="handelChangeJobStatus"
    >
      <template #reference>
        <el-switch v-auto-tooltip.always="$t(`${i18nPrefix}.tips.${jobObj.status === '1' ? 'closeJob' : 'openJob'}`)" class="status-switch" v-model="jobObj.status" inactive-value="0" active-value="1" disabled></el-switch>
      </template>
    </el-popconfirm>
    <div class="applicant_count_container">
      <div class="count-container total">
        <span class="number" @click="handelToApplication">
          {{ jobObj.applicant_info.total | formatBigNumber }}
        </span>
        <span class="label">{{ $t(`${i18nPrefix}.label.total`) }}</span>
        <template v-if="jobObj.applicant_info.not_view">
          <div v-auto-tooltip.always="$t(`${i18nPrefix}.label.new`)" class="un-read-container" @click="handleUnreadClick">{{ jobObj.applicant_info.not_view | formatBigNumber }}</div>
        </template>
      </div>
      <div
        v-for="(group, index) in applicantCountGroup"
        :key="index"
        :class="`count-container ${group.name}`"
      >
        <div class="number-box">
          <span class="number"  @click="handelToApplication($event, group)">{{ (group.count) }}</span>
          <el-popover
            v-if="group.count"
            placement="bottom"
            trigger="click"
            v-model="group.expand"
            :visible-arrow="false">
            <div class="popover-count-container">
              <div
                v-for="statusInfo in group.statusList"
                :key="statusInfo.key"
              >
                <span :class="['count', statusInfo.count && 'has-count']" @click.stop="handelToApplication($event, null, statusInfo.key)">{{ formatBigNumber(statusInfo.count) }}</span>
                <div class="status-name">{{ statusInfo.label }}</div>
              </div>
            </div>
            <i slot="reference" :class="['expand-button', group.expand ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"/>
          </el-popover>
        </div>
        <span class="label">{{ group.label }}</span>
      </div>
      <div v-if="hasLeadsPermission" class="count-container leads">
        <span class="number" @click="handleOpenPotential">{{ jobObj.applicant_info.leads | formatBigNumber }}</span>
        <span class="label">{{ $t(`${i18nPrefix}.label.leads`) }}</span>
      </div>
      <div class="count-container open-days">
        <span class="number">{{ jobObj.open_days | formatBigNumber }}</span>
        <span class="label">{{ $t(`${i18nPrefix}.label.openDays`) }}</span>
      </div>
    </div>
    <DialogWrapper
      class="channel-dialog"
      :show.sync="channelDialog.show"
      :close-on-click-modal="false"
      :hideFooter="true"
    >
      <ChannelDialog v-if="channelDialog.show" ref="jobPostingChannel" :jobId="jobObj.id" :postingChannels="jobObj.job_posting_channels" @handelRefresh="handelChannelRefresh" @jobPostingManual="handleJobPostingManual"/>
    </DialogWrapper>
    <DialogWrapper
      class="channel-dialog"
      :show.sync="shareDialog.show"
      :close-on-click-modal="false"
      :hideFooter="true"
    >
      <ShareDialog v-if="shareDialog.show" :jobId="jobObj.id" :jobName="jobTitle" :isJobShare="true" :shareUrl="shareUrl" @close="handelCloseShareDialog"/>
    </DialogWrapper>
    <AgencyDialog
      v-if="agencyDialog.show"
      :show.sync="agencyDialog.show"
      :jobId="jobObj.id"
    />
    <ConfirmDialog
      v-if="confirmDialog.show"
      :content="confirmDialog.content"
      :show.sync="confirmDialog.show"
      :title="confirmDialog.title"
      :loading="confirmDialog.loading"
      @confirm="confirmDialog.confirmMethod"
      @cancel="confirmDialog.cancelMethod"
    />
    <RectLoading class="loading" v-show="loading"/>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import { formatBigNumber } from '@/components/filters'
import { READ_STATUS } from '@/constant/application'
import { CHANNEL_ICON_MAPPING } from '@/constant/job'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import ConfirmDialog from '@/components/dialog/confirmDialog.vue'
import mixin from './mixin'
import ChannelDialog from './channelDialogContent.vue'
import ShareDialog from './shareJobDialog.vue'
import AgencyDialog from './inviteAgencyDialog.vue'
import RectLoading from '@/components/loading/rectLoading'
import Dropdown from '@/components/formEditor/dropdown.vue'
import { SHOW_HR_JOB_FILTER_ID } from '@/constant/common'
import { getI18nPropertyValue } from '@/i18n'
import { OPERATION_TYPE, JOB_POSTING_STATUS } from '@/constant/company'

const DEFAULT_CHANNEL_ID = 1

export default {
  mixins: [mixin],
  components: {
    DialogWrapper,
    ChannelDialog,
    ShareDialog,
    AgencyDialog,
    ConfirmDialog,
    Dropdown,
    RectLoading
  },
  props: {
    jobObj: {
      required: true
    },
    statisticChannelInfo: {
      default: null
    },
    jobFilterItemBindingList: {
      default: null
    }
  },
  data () {
    return {
      CHANNEL_ICON_MAPPING,
      formatBigNumber,
      i18nPrefix: 'admin.job.list',
      loading: false,
      channelDialog: {
        show: false,
        needRefresh: false
      },
      shareDialog: {
        show: false
      },
      agencyDialog: {
        show: false
      },
      confirmDialog: {
        show: false,
        title: '',
        content: '',
        confirmMethod: null,
        cancelMethod: null,
        loading: false
      },
      referralStatusIconMapping: {
        1: 'draft',
        2: 'pending',
        3: 'approve',
        6: 'rejected',
        7: 'archived'
      },
      channelActionMapping: {
        ADD: 'add',
        DELETE: 'delete',
        UPDATE: 'update'
      },
      loadingStatus: {
        setHot: false,
        setJobStatus: false,
        refreshJob: false
      },
      isActiveTab: true,
      jobPostingManual: false
    }
  },
  computed: {
    showJobStatusSwitch () {
      return this.hasJobEditPermission || this.hasJobClosePermission
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    jobTitle () {
      return this.isEn ? this.jobObj.name : this.jobObj.cn_name
    },
    isJobClosed () {
      return this.jobObj.status === '0'
    },
    openDate () {
      const publishDate = `${moment(this.jobObj.created_time).format('YYYY/MM/DD')}`
      const expireDate = `${moment(this.jobObj.expire_date).format('YYYY/MM/DD')}`
      return `${publishDate}-${expireDate}`
    },
    jobLocation () {
      return _.chain(this.jobObj.city_list).map(city => getI18nPropertyValue(city, 'cn_name', 'name')).join('/').value()
    },
    applicantCountGroup () {
      const groupList = ['SCREEN', 'INTERVIEW', 'OFFER', 'HIRED']
      const result = []
      _.forEach(groupList, (group) => {
        const groupInfo = this.getStatusInfo(group)
        const newGroupInfo = {
          count: formatBigNumber(groupInfo.count),
          name: _.lowerCase(group),
          label: this.$t(`${this.i18nPrefix}.label.${_.lowerCase(group)}`),
          statusList: groupInfo.statusList
        }
        this.$set(newGroupInfo, 'expand', false)
        result.push(newGroupInfo)
      })
      return result
    },
    shareUrl () {
      return `${location.origin}/job-detail-new/${this.jobObj.id}/c/`
    },
    defaultChannel () {
      const defaultChannel = _.find(this.jobObj.job_posting_channels, { id: DEFAULT_CHANNEL_ID })
      if (defaultChannel) {
        if (defaultChannel.status === JOB_POSTING_STATUS.FINISHED) {
          if (defaultChannel.operation_type !== OPERATION_TYPE.DELETE) {
            return {
              actionClass: 'publish',
              ...defaultChannel
            }
          }
        } else {
          return {
            actionClass: this.channelActionMapping[defaultChannel.operation_type],
            ...defaultChannel
          }
        }
      }
      return null
    },
    displayChannelList () {
      const list = []
      _.forEach(this.jobObj.job_posting_channels, (item) => {
        if (item.id === DEFAULT_CHANNEL_ID) {
          return
        }
        if (item.status === JOB_POSTING_STATUS.FINISHED) {
          if (item.operation_type !== OPERATION_TYPE.DELETE) {
            list.push({
              actionClass: 'publish',
              ...item
            })
          }
        } else {
          list.push({
            actionClass: this.channelActionMapping[item.operation_type],
            ...item
          })
        }
      })
      return list
    },
    statisticChannelList () {
      return _.chain(this.statisticChannelInfo).filter(channel => _.has(this.channelStatistic, channel.id)).orderBy('order_index').value()
    },
    channelStatistic () {
      const statistic = this.jobObj.channel_statistic
      const channelIds = _.keys(statistic)
      if (channelIds && channelIds.length > 0) {
        return statistic
      }
      return null
    },
    totalPv () {
      return _.chain(this.channelStatistic).values().sum().add(this.jobObj.pv).value()
    },
    jobFilterBindingList () {
      if (!this.jobFilterItemBindingList || this.jobFilterItemBindingList.length <= 0) {
        return null
      } else {
        return _.map(this.jobFilterItemBindingList, jobFilterItem => ({
          id: jobFilterItem.id,
          value: jobFilterItem.id,
          label: getI18nPropertyValue(jobFilterItem, 'cn_name', 'name')
        }))
      }
    },
    disabledAddCandidate () {
      return this.hasOnlyActionOnMyCandidatePermission && !this.jobObj.is_my_job
    },
    disabledAddCandidateTip () {
      return this.disabledAddCandidate && this.$t('admin.application.applicantList.message.disabledActionCandidateInJob')
    }
  },
  created () {

  },
  mounted () {
    this.$nextTick(() => {
      const container = this.$refs.channelIcon
      const minRight = container.offsetWidth - container.scrollWidth
      if (minRight === 0) {
        return
      }
      container.style.cursor = 'grab'
      container.onmousedown = (de) => {
        container.style.userSelect = 'none'
        let nowRight = container.style.transform || '0'
        nowRight = parseInt(nowRight.replace('translateX(', '').replace(')px', ''))
        document.onmousemove = (me) => {
          const moveX = me.movementX
          nowRight += moveX
          if (nowRight < minRight) {
            nowRight = minRight
          } else if (nowRight > 0) {
            nowRight = 0
          }
          container.style.transform = `translateX(${nowRight}px)`
          container.style.cursor = 'grabbing'
        }

        document.onmouseup = (ue) => {
          document.onmousemove = null
          document.onmouseup = null
          container.style.userSelect = null
          container.style.cursor = 'grab'
        }
      }
    })
    document.addEventListener('visibilitychange', this.handleTabVisibility)
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.handleTabVisibility)
  },
  methods: {
    ...mapActions('company', ['setHotJob', 'refreshJob', 'setJobStatus', 'getCompanyJobList', 'updateJobFilterItemBinding']),
    handelCheckedJob () {
      this.$emit('checkedJob', this.jobObj)
    },
    handelPublish () {
      this.channelDialog.show = true
    },
    handelShare () {
      this.shareDialog.show = true
    },
    handelCloseShareDialog () {
      this.shareDialog.show = false
    },
    handelShareToAgency () {
      this.agencyDialog.show = true
    },
    handelToApplication ($event, candidateStage, candidateStatus) {
      if (!this.jobObj.allow_fetch_application) {
        return
      }
      let path = `/v-admin/job/${this.jobObj.id}/application`
      if (candidateStage) {
        const statusList = _.map(candidateStage.statusList, item => item.key)
        path = `${path}?candidate_status=${encodeURIComponent(statusList)}`
      } else if (candidateStatus) {
        const status = [candidateStatus]
        path = `${path}?candidate_status=${encodeURIComponent(status)}`
      }
      window.open(path)
    },
    handleUnreadClick () {
      if (!this.jobObj.allow_fetch_application) {
        return
      }
      const url = `/v-admin/job/${this.jobObj.id}/application?read_status=${READ_STATUS.UNREAD}`
      window.open(url)
    },
    handleOpenPotential () {
      if (!this.jobObj.allow_fetch_application) {
        return
      }
      const url = `/v-admin/job/${this.jobObj.id}/potential/list`
      window.open(url)
    },
    generateChannelTips (channelInfo) {
      if (!channelInfo) {
        return ''
      }
      let channelName = this.isEn ? channelInfo.name : channelInfo.cn_name
      if (!channelName) {
        channelName = channelInfo.name || channelInfo.cn_name
      }
      if (channelInfo.id === DEFAULT_CHANNEL_ID) {
        channelName = this.isEn ? 'Career Site' : '职位主页'
      }

      let i18nName = 'channelReadyPost'
      if (channelInfo.status === JOB_POSTING_STATUS.FINISHED) {
        i18nName = 'channelAlreadyAction'
      } else if (channelInfo.operation_type === OPERATION_TYPE.DELETE) {
        i18nName = 'channelReadyClose'
      } else if (channelInfo.operation_type === OPERATION_TYPE.UPDATE) {
        i18nName = 'channelReadyRefresh'
      }
      return this.$t(`${this.i18nPrefix}.message.${i18nName}`, { channelName })
    },
    handelToEditJob () {
      window.open(`/v-admin/job/edit/${this.jobObj.id}?back=${encodeURIComponent(this.$route.fullPath)}`)
    },
    getStatusInfo (status) {
      return _.find(this.jobObj.statusCountGroup, ['name', status])
    },
    async handelChangeJobStatus () {
      if (this.loadingStatus.setJobStatus) {
        return
      }
      if (this.jobObj.status === '0' && !this.hasJobEditPermission) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.hasNoPermission`))
        return
      }
      if (this.jobObj.status === '1' && !this.hasJobClosePermission) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.hasNoPermission`))
        return
      }
      this.loadingStatus.setJobStatus = true
      const status = this.jobObj.status === '0' ? '1' : '0'
      try {
        this.jobObj.status = status
        const resp = await this.setJobStatus({ job_ids: this.jobObj.id, action: status === '0' ? 'close' : 'open' })
        if (resp && resp.status === 'success') {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.${status === '0' ? 'closeJobSuccess' : 'openJobSuccess'}`))
          this.refreshJobInfo()
          this.refreshJobList()
        } else if (resp && resp.status === 'failed') {
          this.jobObj.status = status === '0' ? '1' : '0'
          this.$message.warning(this.$t(`${this.i18nPrefix}.message.jobCountNoEnough`))
        } else {
          this.jobObj.status = status === '0' ? '1' : '0'
          this.$message.error(this.$t('error.message.serverError'))
        }
      } finally {
        this.loadingStatus.setJobStatus = false
      }
    },
    addCandidate () {
      if (!this.jobObj.allow_fetch_application) {
        return
      }
      this.$router.push({ path: `/v-admin/application/job/${this.jobObj.id}/add`, query: { back: this.$route.fullPath, is_basic_info: '0' } })
    },
    addCandidateBasicInfo () {
      if (!this.jobObj.allow_fetch_application) {
        return
      }
      this.$router.push({ path: `/v-admin/application/job/${this.jobObj.id}/add`, query: { back: this.$route.fullPath, is_basic_info: '1' } })
    },
    handelActionClick (command) {
      if (command === 'setReferral') {
        this.$router.push({ path: `/v-admin/job/${this.jobObj.id}/referral/`, query: { back: this.$route.fullPath } })
      } else if (command === 'batchAddCandidate') {
        if (!this.jobObj.allow_fetch_application) {
          return
        }
        this.$router.push({ path: `/v-admin/application/${this.jobObj.id}/batch-upload/uploader`, query: { back: this.$route.fullPath } })
      } else if (command === 'refresh') {
        this.showConfirmRefreshDialog()
      } else if (command === 'share') {
        this.handelShare()
      } else if (command === 'postToAgency') {
        this.handelShareToAgency()
      } else if (command === 'close') {
        this.showConfirmCloseDialog()
      }
    },
    async handelHotIconClick () {
      if (this.loadingStatus.setHot) {
        return
      }
      if (!this.hasJobHotSettingPermission) {
        this.loadingStatus.setHot = false
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.hasNoPermission`))
        return
      }
      this.loadingStatus.setHot = true
      try {
        const params = {
          job_id: this.jobObj.id,
          is_hot: !this.jobObj.is_hot
        }
        const resp = await this.setHotJob(params)
        if (resp) {
          this.jobObj.is_hot = !this.jobObj.is_hot
          this.$message.success(this.$t(`${this.i18nPrefix}.message.${this.jobObj.is_hot ? 'setHotJobSuccess' : 'closeHotJobSuccess'}`))
        }
      } finally {
        this.loadingStatus.setHot = false
      }
    },
    showConfirmRefreshDialog () {
      this.confirmDialog.title = this.$t(`${this.i18nPrefix}.label.refresh`)
      this.confirmDialog.content = this.$t(`${this.i18nPrefix}.message.refreshOneJobTip`)
      this.confirmDialog.confirmMethod = this.handelRefreshJob
      this.confirmDialog.cancelMethod = this.handelCancelOption
      this.confirmDialog.show = true
    },
    async handelRefreshJob () {
      this.confirmDialog.loading = true
      try {
        if (this.loadingStatus.refreshJob) {
          return
        }
        this.loadingStatus.refreshJob = true
        try {
          const resp = await this.refreshJob({ job_ids: this.jobObj.id })
          if (resp === 'success') {
            this.$message.success(this.$t(`${this.i18nPrefix}.message.refreshSuccess`))
          } else {
            this.$message.error(this.$t('error.message.serverError'))
          }
        } finally {
          this.loadingStatus.refreshJob = false
        }
        this.confirmDialog.show = false
      } finally {
        this.confirmDialog.loading = false
      }
    },
    handelCancelOption () {
      this.$message.info(this.$t(`${this.i18nPrefix}.message.cancelAction`))
    },
    showConfirmCloseDialog () {
      this.confirmDialog.title = this.$t(`${this.i18nPrefix}.label.closeJob`)
      this.confirmDialog.content = this.$t(`${this.i18nPrefix}.message.closeOneJobTip`)
      this.confirmDialog.confirmMethod = this.handelConfirmCloseJob
      this.confirmDialog.cancelMethod = this.handelCancelOption
      this.confirmDialog.show = true
    },
    async handelConfirmCloseJob () {
      this.confirmDialog.loading = true
      try {
        const params = { job_ids: this.jobObj.id, action: 'close' }
        const resp = await this.setJobStatus(params)
        if (resp && resp.status === 'success') {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.closeJobSuccess`))
          this.refreshJobList()
        } else {
          this.$message.error(this.$t('error.message.serverError'))
        }
        this.confirmDialog.show = false
      } finally {
        this.confirmDialog.loading = false
      }
    },
    async refreshJobInfo (hiddenLoading) {
      if (!hiddenLoading) {
        this.loading = true
      }
      let jobInfo = {}
      try {
        const params = {
          job_id: this.jobObj.id,
          only_one: true
        }
        const resp = await this.getCompanyJobList(params)
        if (resp) {
          jobInfo = resp
          this.$emit('refreshJobInfo', jobInfo)
        }
      } finally {
        this.loading = false
      }
      return jobInfo
    },
    refreshJobList () {
      this.$emit('refreshJobList')
    },
    handelChannelRefresh () {
      this.channelDialog.needRefresh = true
    },
    async handleTabVisibility () {
      if (!this.jobPostingManual || document.hidden) {
        return
      }
      this.$refs.jobPostingChannel?.setChannelLoading(true)
      try {
        await this.refreshJobInfo(true)
      } finally {
        this.jobPostingManual = false
        this.$refs.jobPostingChannel?.setChannelLoading(false)
      }
    },
    async handleJobPostingManual () {
      this.jobPostingManual = true
    },
    getChannelStatistic (channel) {
      const statistic = this.channelStatistic
      if (!statistic) {
        return 0
      }
      return statistic[channel.id] || 0
    },
    async handleFilterBinding (jobFilterBindingId) {
      const data = {
        job_id: this.jobObj.id,
        item_ids: [jobFilterBindingId]
      }
      const resp = await this.updateJobFilterItemBinding({
        filterId: SHOW_HR_JOB_FILTER_ID,
        data
      })
      if (resp) {
        this.$message.success(this.$t(`${this.i18nPrefix}.message.optionSuccess`))
      }
    }
  },
  watch: {
    'channelDialog.show' (newVal) {
      if (newVal === false && this.channelDialog.needRefresh) {
        this.channelDialog.needRefresh = false
        this.$message.success(this.$t(`${this.i18nPrefix}.message.jobChannelChange`))
        this.refreshJobInfo()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.job-item-container {
  padding: 18px 16px;
  background: #FFFFFF;
  box-shadow: 0px 2px 3px -1px rgba(0,0,0,0.08);
  border-radius: 3px;
  border: 1px solid #E4E7ED;
  display: flex;
  align-items: center;
  position: relative;

  .hot-icon {
    cursor: pointer;
    font-size: 16px;
    top: 24px;
    color: #C0C4CC;
    position: absolute;

    &.is-hot {
      color: #EE7815;
    }
  }

  .checkbox-container {
    position: relative;

    .mask {
      width: 100%;
      height: 100%;
      cursor: pointer;
      position: absolute;
      top: 0;
      z-index: 9;
    }
  }

  .custom-field-option {
    position: absolute;
    top: 18px;
    right: 95px;

    .custom-field-dropdown {
      color: #0096CC;
    }
  }

  .job-basic-info {
    flex: 1;
    padding: 0 50px 0 20px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    span {
      white-space: nowrap;
      word-break: keep-all;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
      flex-shrink: 0;
      color: #606266;
    }

    .job-title {
      font-size: 20px;
      line-height: 28px;
      height: 28px;
      font-weight: 500;
      color: #0096CC;
      cursor: pointer;
      position: relative;
    }

    .basic-info {
      margin: 6px 0;
      display: inline-flex;
      overflow: hidden;

      > span {
        line-height: 20px;
      }

      .creator {
        overflow: hidden;
        text-overflow: ellipsis;
        flex-shrink: 1;
        margin-left: 15px;
      }
      .open-date {
        margin-left: 15px;
      }
    }

    .job-location {
      line-height: 20px;
      height: 20px;
    }

    .channel-container {
      max-width: 340px;
      padding: 6px 0 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .channel-icon {
        margin-right: 8px;
        height: 32px;
        padding-top: 3px;

        &::before {
          border-radius: 50%;
          padding: 1px;
          border: 2px solid #FFFFFF;
          border-color: inherit;
        }

        &.draft {
          border-color: #F4A958;
        }
        &.pending {
          border-color: #F4A958;
        }
        &.approve {
          border-color: #51BF82;
        }
        &.rejected {
          border-color: #EA7F7F;
        }
        &.archived {
          border-color: #EA7F7F;
        }

        &.publish {
          border-color: #51BF82;
        }

        &.add {
          border-color: #F4A958;
        }
        &.delete {
          border-color: #EA7F7F;
        }
        &.update {
          border-color: #0896dd;
        }
      }

      .iconfont {
        font-size: 24px;
        margin-right: 8px;
        color: #0096CC;
        display: inline-block;
      }

      .icon-container {
        flex: 1;
        overflow: hidden;
        margin-right: 8px;

        .channel-icon-container {
          display: flex;
          white-space: nowrap;
          transform: translateX(0px);
        }
      }

      .pv-share-container {
        display: flex;
        align-items: center;

        > span {
          margin-right: 4px;
          padding-right: 1px;
        }

        .pv-uv {
          margin-right: 10px;
        }

        .share {
          margin: 0;
        }

        .number {
          font-size: 14px;
          width: auto;
          color: #606266;
        }
      }
    }

    .operate-container {
      display: flex;
      align-items: center;

      .iconfont {
        font-size: 30px;
        color: #0096CC;
        cursor: pointer;
        height: unset;
        margin-right: 10px;
        line-height: unset;
      }

      .icona-xingzhuangbeifen8 {
        font-size: 22px;
        color: #606266;
      }

      .publish-button {
        padding: 4px 22px;
        font-size: 14px;
        border-radius: 2px;
        border-width: 2px;
        margin-right: 15px;
        background: #FFFFFF;
        color: #0096CC;
        border-color: #0096CC;

        &:not(.disabled):hover {
          background: #0096CC;
          color: #FFF;
        }

        &.disabled {
          cursor: not-allowed;
        }
      }

      .edit-icon {
        font-size: 26px;
      }
    }
  }

  .status-switch {
    position: absolute;
    right: 16px;
    top: 18px;
    opacity: unset;

    &::v-deep {
      &.is-disabled {
        .el-switch__core {
          cursor: pointer;
        }
      }
    }
  }

  .applicant_count_container {
    display: flex;
    margin-top: 16px;
    justify-content: flex-end;

    .count-container {
      width: 81px;
      background: #FFFFFF;
      border: 1px solid #DCDFE6;
      display: flex;
      padding: 36px 0 24px 0;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .expand-button {
        cursor: pointer;
      }

      .number {
        font-size: 18px;
        line-height: 25px;
        height: 25px;
        font-weight: 400;
        color: #606266;
        cursor: pointer;

        &:hover {
          color: #0096CC;
        }
      }

      .label {
        font-size: 14px;
        color: #909399;
        font-weight: 400;
        line-height: 19px;
        height: 19px;
      }

      .un-read-container {
        color: #0096cc;
        font-size: 12px;
        line-height: 1;
        font-weight: bold;
        text-align: right;
        position: absolute;
        top: 6px;
        right: 6px;
        cursor: pointer;
      }

      .el-icon-caret-bottom {
        font-size: 14px;
        color: #909399;
      }

      .number-box {
        display: flex;
        align-items: center;
      }

      &.total {
        border-right: 0;
        position: relative;
      }

      &.screen {
        border-right: 0;
      }

      &.offer {
        border-right: 0;
      }

      &.interview {
        border-right: 0;
      }

      &.leads {
        margin-left: 6px;
      }

      &.open-days {
        margin-left: 6px;
        .number {
          cursor: unset;
          &:hover {
            color: #606266;
          }
        }
      }
    }
  }

  .loading {
    position: absolute;
  }

  &.not-allow-application {
    .job-basic-info {
      .job-title {
        display: flex;
        cursor: default;

        .job-title-inner {
          flex-shrink: 1;
          font-size: 20px;
          line-height: 28px;
          height: 28px;
          font-weight: 500;
          color: #606266;
        }

        .not-allow-tip {
          flex-shrink: 0;
          margin-left: 10px;
          line-height: 1;
          cursor: help;
        }
      }
    }

    .applicant_count_container {
      .count-container {
        .number {
          cursor: default;
          color: #606266;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.job-list-item-dropdown-container {
  .dropdown-item {
    font-size: 14px;
    line-height: 36px;
    padding: 0 20px;
    color: #606266;

    &:hover {
      background: #F0F0F0;
    }

    &.is-disabled {
      color: #bbb;
      cursor: not-allowed;
    }
  }

  &.el-dropdown-menu  {
    padding: 0;

    .el-dropdown-menu__item {
      &:hover {
        background: #F0F0F0;
      }
    }
  }

  &.el-popper {
    .popper__arrow {
      display: none;
    }
  }
}

.popover-count-container {
  display: flex;
  overflow: auto;
  max-width: 518px;
  padding: 2px;

  > div {
    width: 97px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #DCDFE6;
    border-right: 0;
    padding: 8px;

    &:last-child {
      border-right: 1px solid #DCDFE6;
    }
  }

  span {
    text-align: center;
    word-break: keep-all;
  }

  .count {
    font-size: 16px;
    margin-bottom: 6px;
    cursor: pointer;
    &:hover {
      color: #0096CC;
    }
  }

  .status-name {
    font-size: 12px;
    display: flex;
    word-break: break-word;
    cursor: default;
    flex-grow: 1;
    align-items: center;
    text-align: center;
  }
}

.add-candidate-action-container {
  padding: 10px 0;

  .popover-item {
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    cursor: pointer;

    &:hover {
      color: #0096cc;
      background-color: #ecf5ff;
    }
  }
}

.pv-share-tooltip-container {
  .channel-statistic-list {
    .channel-statistic {
      margin: 5px auto;

      .channel-icon {
        margin-right: 8px;
        font-size: 24px;
        color: #0096cc;
        vertical-align: middle;
      }

      .channel-icon {
        vertical-align: middle;
      }
    }
  }
}
</style>
